import { useContext } from "react";
import { RootStoreContext } from "@/contexts/storesContext";
import RootStore from "@/stores/rootStore";

const useStore = <T extends keyof RootStore>(storeName: T): RootStore[T] => {
  const context = useContext(RootStoreContext);

  if (context === null) {
    throw new Error();
  }
  return context[storeName];
};

export default useStore;
